import FormMessageHandler from '../components/formMessageHandler';

const $body = $('body');
if ($body.hasClass('page--reset-password')) {
  class ResetPassword {
    constructor() {
      let Spinner = require('spin');
      this.cacoo = require('../components/cacoo').cacoo;

      this.$resetPasswordForm = $('.account-form__reset-password-form', $body);
      this.$sendButton = $('.js_reset_password_button', this.$resetPasswordForm);
      this.$password = $('#password', this.$resetPasswordForm);
      this.$confirmPasswrd = $('#confirm', this.$resetPasswordForm);
      this.$key = $('#key', this.$resetPasswordForm);
      this.$email = $('#email', this.$resetPasswordForm);
      this.formMessageHandler = new FormMessageHandler(this.$resetPasswordForm);
      this.$successMessage =  $('.forms-success-message');
      this.successOverlay = $('.reset_password_success__overlay');
      this.successMessage = $('.reset_password__success');

      this.buttonSpinner = new Spinner({color: '#fff', lines: 12});
      this.attachEvent();
    }

    attachEvent() {
      this.$sendButton.on('click', () => {
        this.resetPassword();
      });

      $('input', this.$resetPasswordForm).on('keypress', (e) => {
        if (e.which === 13) {
          this.resetPassword();
        }
      });

    }

    resetPassword() {
      if (this.$sendButton.hasClass('disable') || !this.validate()) {
        return false;
      }

      const data = {
        "email": this.$email.val(),
        "password": this.$password.val(),
        "key": this.$key.val(),
        "confirmPassword": this.$confirmPasswrd.val()
      };

      this.cacoo.ajax({
        url: `${Cacoo.settings.baseUrl}/api/site/resetPassword`,
        method: "POST",
        data: data,
        beforeSend: () => {
          this.startButtonSpinner();
        },
        success: () => {
          this.stopButtonSpinner();
          this.showSuccessMessage();
        },
        error: (err) => {
          this.stopButtonSpinner();
          const response = err.responseJSON;
          if (response.errors) {
            this.formMessageHandler.showError('default', response.errors[0].message);
          } else {
            this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signup_default_error']);
          }

          return false;

        },
        timeout: 30000
      })
    }

    validate() {
      if (this.$password.val().length < 8 || this.$password.val().length > 200) {
        this.formMessageHandler.showError('password', Cacoo.SiteResources['modal_signup_password_error']);
        return false
      } else {
        this.formMessageHandler.showSuccess('password')
      }

      if (this.$confirmPasswrd.val() !== this.$password.val()) {
        this.formMessageHandler.showError('confirm', Cacoo.SiteResources['reset_password_reenter_password']);
        return false
      } else {
        this.formMessageHandler.showSuccess('confirm')
      }

      return true
    }

    showSuccessMessage() {
      this.$successMessage.show();
      $.Velocity.animate(this.successOverlay, {
        opacity: .9
      }, {
        visibility: "visible"
      });

      $.Velocity.animate(this.successMessage, {
        opacity: 1
      }, {
        visibility: "visible"
      });
    }

    startButtonSpinner() {
      this.$sendButton.addClass('disable');
      this.buttonSpinner.spin(this.$sendButton.get(0));
    }

    stopButtonSpinner() {
      this.$sendButton.removeClass('disable');
      this.buttonSpinner.stop();
    }
  }

  new ResetPassword();
}
